// @ts-nocheck
import { isEqual } from 'lodash-es';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
  HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse,
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { STORAGE, StorageService } from '../service/storage.service';

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  constructor(
    private storage: StorageService,
  ) {
  }

  /**
   * .
   * @param request .
   * @param next .
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next
      .handle(request)
      .pipe(tap((response: any) => {
        //
        if (response instanceof HttpResponse) {
          // get body
          const body: HTMLBodyElement = document.querySelector('body');
          if (!body) { return; }
          // get current version id from body
          const currentVersion: string = body.getAttribute('data-version');

          const headers: HttpHeaders = response.headers;
          // get latest version id from API response headers
          const latestVersion: string = headers.get('Proportunity-Client-Version');
          if (!currentVersion || !latestVersion) { return; }
          // generate a force reload id
          const forceReloadId = `${currentVersion}-${latestVersion}`;
          // check if force reload id is found in local storage
          const previousForceReload: boolean = !!this.storage.get(STORAGE.LOCAL, forceReloadId);
          // if current version is different from latest version and no previous force reload id found in storage
          if (!isEqual(currentVersion, latestVersion)
            && !previousForceReload) {
            // commit force reload id to local storage
            this.storage.set(STORAGE.LOCAL, forceReloadId, '1');
            // notify user a new version is available
            window
              .alert('An update is available. Your browser will reload.');
            // reload browser
            document.location.reload();
          }
        }
      }));
  }
}
